'use strict';

// Import Libraries
import React from 'react';

// --------------------------------------------------------------------

const TYPES = {
  designs: 'designs',
  design: 'design',
  photos: 'photos',
  layouts: 'layouts',
  favourites: 'favourites',
  colours: 'colours',
  text: 'text',
  events: 'events',
  options: 'options',
  wraps: 'wraps',
  stickers: 'stickers',
  patterns: 'patterns',
};

// --------------------------------------------------------------------

class TrayBase extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  get name() {
    return this.props.name;
  }

  get type() {
    return TYPES[this.name];
  }
}

// --------------------------------------------------------------------

export { TYPES, TrayBase };
